const pl = {
  firstDayWeek: 'Pierwszy dzień tygodnia',
  startScreen: 'Ekran startowy',
  blackTheme: 'Ciemny motyw',
  backgroundImage: 'Obrazek tła',
  language: 'Język',
  sounds: 'Dźwięki',
  home: 'Dom',
  calendar: 'Kalendarz',
  settings: 'Ustawienia',
  noTasks: 'Brak zadań',
  myTasks: 'Moje zadania',
  chooseImage: 'Wybierz zdjęcie w tle:',
  saveChanges: 'Zapisz',
  edit: 'Edytuj',
  add: 'Dodaj',
  close: 'ZAMKNIJ',
  taskManager: 'Menadżer zadań'
};

export default pl;
